<template>
  <div>
    <va-modal
      class="modal"
      v-model="showModal"
      max-width="100%"
      :hideDefaultActions="true"
      noEscDismiss
      noOutsideDismiss
      title="Gestion du retour"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md12" v-if="identreprise && isready">
            <va-input
              label="entreprise"
              disabled
              v-model="entreprise.nom"
            ></va-input>
          </div>
          <div class="flex md12" v-if="!identreprise && isready">
            <va-select
              label="Selection de l'entreprise"
              key-by="identreprise"
              text-by="nom"
              :options="listeEntreprise"
              placeholder="Selection de l'entreprise"
              v-model="identrepriseSelect"
              searchable
            />
          </div>
          <div class="flex md12 pa-2">
            Créé par : {{ utilisateur }} {{ idretour ? dateRetour : "" }}
          </div>
          <div class="flex md6">
            <va-date-picker
              :config="{ dateFormat: 'd-m-Y' }"
              label="Date du retour"
              v-model="dateRetour"
            />
          </div>

          <div class="flex md3 offset--md3 px-2">
            <va-button
              outline
              small
              class="fullwidth"
              :color="descLevel.color"
              >{{ descLevel.text }}</va-button
            >
          </div>
          <div class="flex md2 my-2">
            <va-checkbox label="Retour définitif" v-model="isDefinitif" />
          </div>
          <div class="flex md3 my-2">
            <va-checkbox
              label="Traitement prioritaire"
              v-model="isPrioritaire"
            />
          </div>
          <div class="flex md12">
            <va-select
              label="Selection du motif de retour"
              key-by="idretours_courrier_type"
              text-by="motif"
              :options="listeMotifs"
              placeholder="Selection du motif de retour"
              v-model="motifSelect"
            />
          </div>
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md2">
                <va-radio-button
                  option="courrier"
                  label="Courrier"
                  v-model="retourType"
                />
              </div>
              <div class="flex md2">
                <va-radio-button
                  option="journal"
                  label="Journal"
                  v-model="retourType"
                />
              </div>
              <div class="flex md6" v-if="retourType === 'journal'">
                <va-select
                  label="Selection du journal"
                  key-by="idpublication"
                  text-by="numero"
                  :options="listeJournaux"
                  placeholder="Selection du journal"
                  v-model="journalSelect"
                />
              </div>
            </div>
          </div>
          <div class="flex md12 my-4">
            <va-input
              v-model="comment"
              label="Commentaire:"
              type="textarea"
              autosize
              :minRows="8"
              :maxRows="8"
            />
          </div>
          <div class="flex md2">
            <va-button
              v-if="idretour"
              class="fullwidth"
              color="danger"
              @click="showConfirmDelete = true"
              >Supprimer</va-button
            >
          </div>
          <div class="flex md2 offset--md5">
            <va-button class="fullwidth" color="info" @click="closeModal"
              >Annuler</va-button
            >
          </div>
          <div class="flex md2">
            <va-button class="fullwidth" color="success" @click="createRetour"
              >Sauvegarder</va-button
            >
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      :style="{ 'z-index': '1500' }"
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer ce retour?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteRetour()"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { find } from "lodash";

export default {
  name: "gestion-retour",
  props: ["value", "identreprise", "idretour"],
  data() {
    return {
      showConfirmDelete: false,
      isDefinitif: false,
      isPrioritaire: false,
      showModal: false,
      entreprise: null,
      identrepriseSelect: "",
      listeEntreprise: [],
      isready: false,
      dateRetour: moment().format("DD-MM-YYYY"),
      listeMotifs: [],
      motifSelect: "",
      retourType: "",
      listeJournaux: [],
      journalSelect: "",
      utilisateur:
        this.$store.getters.user.prenom + " " + this.$store.getters.user.nom,
      returnLevel: 1,
      comment: "",
    };
  },
  mounted() {
    this.showModal = this.value; // initialize internal variables
  },
  computed: {
    descLevel() {
      if (this.returnLevel === 1) {
        return { text: "1er retour", color: "info" };
      } else if (this.returnLevel === 2) {
        return { text: "2eme retour", color: "warning" };
      } else if (this.returnLevel === 3) {
        return { text: "3eme retour", color: "danger" };
      } else {
        return { text: "Retour", color: "gray" };
      }
    },
  },
  watch: {
    value(newValue) {
      console.log(newValue);
      // Parent property changed; update internal variables
      if (newValue === true) {
        this.loadInfos();
      }
      this.showModal = this.value;
    },
    closeModal() {
      this.resetRetour();
      this.$emit("close", false);
      this.$emit("input", false);
    },
  },
  created() {
    this.getListMotifs();
    this.getListJournaux();
  },
  methods: {
    async deleteRetour() {
      try {
        let retourRaw = await axios.delete("/api/retours/retour", {
          params: { idretour: this.idretour },
        });
        this.$emit("update", retourRaw.data);
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de la suppression");
      }
    },
    closeModal() {
      this.$emit("close", false);
      this.$emit("input", false);
    },
    async getListEntreprises() {
      try {
        let res = await axios.get("/api/retours/liste-entreprises");

        this.listeEntreprise = res.data.listeEntreprise;
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getRetour() {
      try {
        let res = await axios.get("api/retours/retour", {
          params: { idretour: this.idretour },
        });
        // fill infos
        let retour = res.data;
        this.isPrioritaire = !!retour.prioritaire;
        console.log(retour);
        this.listeEntreprise = [];
        this.identrepriseSelect = "";
        this.dateRetour = moment(retour.date_retour, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
        this.motifSelect = {
          idretours_courrier_type: retour.motif,
          motif: retour.motif_text,
        };
        this.retourType = retour.type;
        if (retour.type === "journal") {
          this.journalSelect = find(this.listeJournaux, [
            "idpublication",
            retour.idpublication,
          ]);
        } else {
          this.journalSelect = "";
        }
        this.isDefinitif = !!retour.definitif;
        this.comment = retour.commentaire;
        this.entreprise = {
          identreprise: retour.identreprise,
          nom: retour.nom_entreprise,
        };
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getInfosEntreprise() {
      try {
        let res = await axios.get("api/retours/infos-entreprise", {
          params: { identreprise: this.identreprise },
        });

        this.entreprise = res.data;
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getListJournaux() {
      try {
        let res = await axios.get("api/retours/liste-numeros-journal");

        this.listeJournaux = res.data.listeJournaux;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getListMotifs() {
      try {
        let res = await axios.get("api/retours/liste-types-retours");

        this.listeMotifs = res.data.listeTypes;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async createRetour() {
      try {
        // case firm already selected
        if (this.entreprise) {
          this.identrepriseSelect = {
            identreprise: this.entreprise.identreprise,
          };
        }

        if (!this.identrepriseSelect) {
          this.launchToast("Entreprise non selectionnée");
          return;
        }

        if (!this.dateRetour) {
          this.launchToast("Date du retour non renseignée");
          return;
        }
        if (!this.motifSelect) {
          this.launchToast("Motif non renseigné");
          return;
        }
        if (!this.retourType) {
          this.launchToast("Type de retour non renseigné");
          return;
        }

        if (this.retourType === "journal" && !this.journalSelect) {
          this.launchToast("Journal non renseigné");
          return;
        }

        let retour = {
          identreprise: this.identrepriseSelect.identreprise,
          date_retour: moment(this.dateRetour, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          motif: this.motifSelect.idretours_courrier_type,
          commentaire: this.comment,
          type: this.retourType,
          idjournal: this.journalSelect.idpublication,
          definitif: this.isDefinitif,
          prioritaire: this.isPrioritaire,
        };

        //modification
        if (this.idretour) {
          retour.idretour_entreprise = this.idretour;
          let newRetour = await axios.put("/api/retours/update-retour", {
            retour: retour,
          });
          newRetour.data.hist_type = "retour";
          this.$emit("update", newRetour.data);
        } else {
          //creation
          let newRetour = await axios.post("/api/retours/retour", {
            retour: retour,
          });
          this.$emit("new", newRetour.data);
        }

        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    resetRetour() {
      this.isready = false;
      this.listeEntreprise = [];
      this.identrepriseSelect = "";
      this.dateRetour = moment().format("DD-MM-YYYY");
      this.motifSelect = "";
      this.journalSelect = "";
      this.returnLevel = 1;
      this.isDefinitif = false;
      this.isPrioritaire = false;
      this.comment = "";
      this.entreprise = null;
      this.retourType = null;
    },
    loadInfos() {
      this.resetRetour();
      if (this.idretour) {
        this.getRetour();
        return;
      } else if (this.identreprise) {
        this.getInfosEntreprise();
        return;
      } else {
        this.getListEntreprises();
        return;
      }
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 40vw;
  overflow: auto;
}

.fullwidth {
  width: 95%;
}
</style>
